export enum AssetTypeField {
  TEXT = "Text",
  VISUAL = "Image",
  VISUAL_AND_TEXT = "Image + description",
  VIDEO_SCRIPT = "Video Script",
}
